export const keyNameSessionStorage = {
    accessToken: 'selfAccessToken',
    refreshToken: 'selfRefreshToken',
    user: 'selfUser',
    // singIn: 'selfSingIn',
}

export const setSessionStorage = (key: string, value: string): void => sessionStorage.setItem(key, value)

export const getSessionStorage = (key: string): string | null => sessionStorage.getItem(key)

export const removeSessionStorage = (key: string[]): void => {
    key.forEach((k) => {
        sessionStorage.removeItem(k)
    })
}

export const clearAllSessionStorage = (): void => sessionStorage.clear()

export const getAccessToken = () => getSessionStorage(keyNameSessionStorage.accessToken)
export const getRefreshToken = () => getSessionStorage(keyNameSessionStorage.refreshToken)

export const setAccessToken = (value: string) => setSessionStorage(keyNameSessionStorage.accessToken ,value)
export const setRefreshToken = (value: string) => setSessionStorage(keyNameSessionStorage.refreshToken ,value)
